import React, { useEffect, useState } from "react";
import {
  Emailvalidate,
  GET_INNER_FOLDER_DATA,
  Otpvalidation,
} from "../../DAM_API/urls";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";

import FolderGridSecondVersion from "../../Common/Designs/CommonFolder";
import ImageGridSecondVersion from "../../Common/Designs/CommonAssets";
import { CommonSvg } from "../../Common/SVG";
import CommonAuthPopup from "../../Common/CommonAuthPopup";

import "./innerFolder.css";
import { useDownloadAssets } from "../../../context/DownloadAssetsContext";
import Axios from "../../../utils/Axios";

/* ---------------- Range Selection (UNCHANGED) ---------------- */

export function selectRangeByUUID(
  data,
  startId,
  endId,
  filterId = "damFileId",
) {
  const startIndex = data.findIndex((item) => item[filterId] === startId);
  const endIndex = data.findIndex((item) => item[filterId] === endId);

  if (startIndex === -1 || endIndex === -1) return data;

  const min = Math.min(startIndex, endIndex);
  const max = Math.max(startIndex, endIndex);

  return data.map((item, index) => ({
    ...item,
    isSelected: !item?.isSelected
      ? index >= min && index <= max
      : item.isSelected,
  }));
}

/* ---------------- Component ---------------- */

function Innerfolder() {
  const { id } = useParams();

  const [showemail, setshowemail] = useState(true);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [popupMode, setPopupMode] = useState("email");

  const [sharedData, setSharedData] = useState();
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [filterState, setFilterState] = useState({});
  const [loading, setloading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const { startDownload } = useDownloadAssets();

  /* ---------------- Fetch Inner Folder ---------------- */

  const Shareimage = async () => {
    if (
      filterState?.searchInput?.length > 0 &&
      filterState?.searchInput?.length < 3
    ) {
      return;
    }

    try {
      const response = await Axios.get(GET_INNER_FOLDER_DATA, {
        params: {
          folderId: id,
          searchKeyword: filterState?.searchInput ?? "",
        },
      });

      setSharedData({
        files: response?.data?.data?.images ?? [],
        folders: response?.data?.data?.folders?.[0]?.subfolders ?? [],
      });
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };

  useEffect(() => {
    if (id) Shareimage();
  }, [id, filterState]);

  /* ---------------- Auth ---------------- */

  const handleotp = async () => {
    try {
      setButtonLoading(true);
      const res = await Axios.post(Emailvalidate, {
        email,
        uniqueId: id,
      });

      if (res.data.data.includes("OTP")) {
        setPopupMode("otp");
      } else {
        setPopupMode(null);
        setshowemail(true);
        Shareimage(id);
      }
    } catch (e) {
      toast.error(e?.response?.data?.data);
    } finally {
      setButtonLoading(false);
    }
  };

  const sendotp = async () => {
    try {
      setButtonLoading(true);
      const res = await Axios.post(Otpvalidation, {
        shareUniqueId: id,
        otp,
        email,
      });

      setSharedData({
        files: res?.data?.data?.images ?? [],
        folders: res?.data?.data?.folders?.[0]?.subfolders ?? [],
      });

      setPopupMode(null);
      setshowemail(true);
    } catch (e) {
      toast.error(e?.response?.data?.message);
    } finally {
      setButtonLoading(false);
    }
  };

  /* ---------------- Download ---------------- */

  const downloadHandler = async () => {
    try {
      setloading(true);
      var _data = {
        fileId: sharedData?.files
          ?.filter((i) => i?.isSelected)
          ?.map((i) => i?.assetId),
        folderId: sharedData?.folders
          ?.filter((i) => i?.isSelected)
          ?.map((i) => i?.id),
        files: sharedData?.files?.filter((i) => i?.isSelected)?.map((i) => i),
        email,
      };
      const res = await startDownload(_data);
    } catch {
      toast.error("Download failed");
    } finally {
      setloading(false);
    }
  };

  /* ---------------- Auth UI ---------------- */

  if (!showemail) {
    return (
      <CommonAuthPopup
        isOpen
        mode={popupMode}
        email={email}
        setEmail={setEmail}
        otp={otp}
        setOtp={setOtp}
        onSubmit={popupMode === "email" ? handleotp : sendotp}
        onClose={() => setPopupMode(null)}
        buttonLoading={buttonLoading}
      />
    );
  }

  /* ---------------- Main UI ---------------- */

  return (
    <div className="container inner-folder-page">
      {/* Header */}
      <div className="page-header">
        <h2>Assets</h2>

        {(sharedData?.files?.some((i) => i?.isSelected) ||
          sharedData?.folders?.some((i) => i?.isSelected)) && (
          <button
            className="Primary-Button d-flex gap-2"
            onClick={downloadHandler}
            disabled={loading}
          >
            Download {loading && <Spinner size="sm" />}
          </button>
        )}
      </div>

      {/* Search */}
      <div className="search-row">
        <div className="search-box">
          {CommonSvg.searchIconSvg}
          <input
            type="search"
            placeholder="Search Assets"
            value={filterState?.searchInput || ""}
            onChange={(e) =>
              setFilterState((p) => ({
                ...p,
                searchInput: e.target.value,
              }))
            }
          />
        </div>
      </div>

      {/* Folders */}
      <div className="folder-grid">
        {sharedData?.folders?.map((item) => (
          <FolderGridSecondVersion
            key={item.id}
            Title={item.folderName}
            Data={item}
            isSelected={item.isSelected}
            HandleSelect={(value) => {
              if (value?.Key === 3) {
                const range = selectRangeByUUID(
                  sharedData.folders,
                  prevIndexSelected,
                  item.id,
                  "id",
                );
                setSharedData((p) => ({ ...p, folders: range }));
              }

              if (value?.Key === 1 || value?.Key === 2) {
                setPrevIndexSelected(item.id);
                setSharedData((p) => ({
                  ...p,
                  folders: p.folders.map((f) =>
                    f.id === item.id
                      ? { ...f, isSelected: !f.isSelected }
                      : value.Key === 1
                        ? { ...f, isSelected: false }
                        : f,
                  ),
                }));
              }
            }}
          />
        ))}
      </div>

      {/* Files */}
      <div className="asset-grid">
        {sharedData?.files?.map((item) => (
          <ImageGridSecondVersion
            key={item.assetId}
            Data={item}
            EllipseActions={CommonSvg.downloadIconsSvg}
            isSelected={item.isSelected}
            HandleSelect={(value) => {
              if (value?.Key === 3) {
                const range = selectRangeByUUID(
                  sharedData.files,
                  prevIndexSelected,
                  item.assetId,
                  "assetId",
                );
                setSharedData((p) => ({ ...p, files: range }));
              }

              if (value?.Key === 1 || value?.Key === 2) {
                setPrevIndexSelected(item.assetId);
                setSharedData((p) => ({
                  ...p,
                  files: p.files.map((f) =>
                    f.assetId === item.assetId
                      ? { ...f, isSelected: !f.isSelected }
                      : value.Key === 1
                        ? { ...f, isSelected: false }
                        : f,
                  ),
                }));
              }
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default Innerfolder;
